<template>
  <div class="gallery" v-images-loaded:on.progress="imageProgress">
    <template v-if="!loadingQuery">
      <transition name="fade">
        <Loading :progress="progress" v-if="loading" />
      </transition>
      <HomeGalleryImage
        v-for="({ slug, acf_shooting }, i) in images"
        :class="
          `${acf_shooting.thumbnailShooting.categories.nodes
            .map(({ slug }) => slug)
            .join(' ')} ${slug}`
        "
        :key="i"
        :src="acf_shooting.thumbnailShooting.sourceUrl"
        :srcset="acf_shooting.thumbnailShooting.srcSet"
        :alt="acf_shooting.thumbnailShooting.altText"
        :active="i < n"
      />
    </template>
  </div>
</template>

<script>
import { useQuery, useResult } from "@vue/apollo-composable";
import { ALL_IMAGES } from "../queries";

import { watch, ref } from "@vue/composition-api";

import HomeGalleryImage from "./HomeGalleryImage";
import Loading from "./Loading";

import { useImageLoading } from "../compositions/useImageLoading";

export default {
  name: "HomeGallery",
  components: {
    HomeGalleryImage,
    Loading,
  },
  setup(props, { emit }) {
    const number = 15;
    const n = ref(0);
    const { result, loading: loadingQuery } = useQuery(ALL_IMAGES, { number });
    const images = useResult(result, null, (data) => data.posts.nodes);

    const [progress, loading, imageProgress] = useImageLoading();

    watch(loading, (newVal) => {
      if (!newVal) {
        const timer = setInterval(() => {
          n.value++;
          if (n.value == number) {
            clearInterval(timer);
            emit("loaded");
          }
        }, 150);
      }
    });

    return {
      images,
      loadingQuery,
      loading,
      imageProgress,
      progress,
      n,
    };
  },
};
</script>

<style lang="scss" scoped>
.gallery {
  pointer-events: none;
  position: fixed;
  overflow: hidden;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
